import React from 'react'

import { type CustomerAttributeGroup } from '~/hooks/useSurveyQuery'
import { findByPath } from '~/utils'

import { useCustomerAttributesArrayData } from './useCustomerAttributesArrayData'

export const useCustomerAttributesData = (
  customerAttributeGroup: CustomerAttributeGroup,
) => {
  const customerAttributesArrayData = useCustomerAttributesArrayData()

  return React.useMemo(
    () =>
      findByPath(
        customerAttributesArrayData,
        '0.customerAttributeGroup.id',
        customerAttributeGroup.id,
      ) ?? [],
    [customerAttributeGroup.id, customerAttributesArrayData],
  )
}
